"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var InterswitchDepositWorkflowComponent = /*#__PURE__*/function (_React$Component) {
  function InterswitchDepositWorkflowComponent() {
    _classCallCheck(this, InterswitchDepositWorkflowComponent);
    return _callSuper(this, InterswitchDepositWorkflowComponent, arguments);
  }
  _inherits(InterswitchDepositWorkflowComponent, _React$Component);
  return _createClass(InterswitchDepositWorkflowComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.form.submit();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var options = this.props.options;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Redirecting to Interswitch..."), /*#__PURE__*/_react["default"].createElement("form", {
        id: "interswitchForm",
        style: {
          visibility: 'hidden'
        },
        action: options.postUrl,
        method: "post",
        ref: function ref(form) {
          return _this.form = form;
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: "product_id",
        type: "text",
        value: options.productId
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "pay_item_id",
        type: "text",
        value: options.itemId
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "amount",
        type: "text",
        value: options.amount
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "currency",
        type: "text",
        value: options.currency
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "site_redirect_url",
        type: "text",
        value: options.siteRedirectUrl
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "txn_ref",
        type: "text",
        value: options.transRef
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "cust_id",
        type: "text",
        value: options.customerId
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "hash",
        type: "text",
        value: options.hash
      })));
    }
  }]);
}(_react["default"].Component);
InterswitchDepositWorkflowComponent.defaultProps = {
  options: {
    postUrl: '',
    productId: '',
    itemId: '',
    amount: '',
    currency: '',
    siteRedirectUrl: '',
    transRef: '',
    customerId: '',
    hash: ''
  }
};
InterswitchDepositWorkflowComponent.propTypes = {
  options: _propTypes["default"].shape({
    postUrl: _propTypes["default"].string,
    productId: _propTypes["default"].string,
    itemId: _propTypes["default"].string,
    amount: _propTypes["default"].string,
    currency: _propTypes["default"].string,
    siteRedirectUrl: _propTypes["default"].string,
    transRef: _propTypes["default"].string,
    customerId: _propTypes["default"].string,
    hash: _propTypes["default"].string
  })
};
var _default = exports["default"] = InterswitchDepositWorkflowComponent;